import { useState, useEffect, ReactNode } from "react";

import "./style.scss";
import { ThemeContainer } from "../../common/containers/theme/theme.container";
import { getLogoImg } from "../../common/utilities/logo/logo.util";

export const AuthTemplate = ({ children }: { children: ReactNode }) => {
    const { logo, color } = ThemeContainer.useContainer();
    const [logoImg, setLogoImg] = useState<string>(getLogoImg(logo));

    useEffect(() => {
        setLogoImg(getLogoImg(logo));
    }, [logo]);

    return (
        <div className="auth-template">
            <div className="auth-template-content">{children}</div>
            <div className="auth-template-logo" style={{ background: color }}>
                <img src={logoImg} className="auth-template-logo__img" alt="" />
            </div>
        </div>
    );
};
